// import React from "react";
// import { NavLink } from "react-router-dom";
// import logo from '../assets/Home/logo.png'
// import './Header.css'

// const Header = () => {
//   return (
//     <header className="header">
//       <div style={{width:'20%'}}>
//         <img src={logo}  style={{width:'100%'}}/>
//       </div>

//       <nav className="nav">
//         <NavLink to="/" className="link" end>Home</NavLink>
//         <NavLink to="/about" className="link">About Us</NavLink>
//         <NavLink to="/services" className="link">Services</NavLink>
//         <NavLink to="/projects" className="link">Projects</NavLink>
//         <NavLink to="/companyCulture" className="link">Company Culture</NavLink>
//         <NavLink to="/contact" className="link">Contact Us</NavLink>
//       </nav>

//       <div>
//         <button className="buttonStyle" >Get a Quote</button>
//       </div>
//     </header>
//   );
// };

// export default Header;


import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import logo from '../assets/Home/logo.png';
import { Link } from 'react-router-dom';
import './Header.css';

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => setMenuOpen(prev => !prev);
  const closeMenu = () => setMenuOpen(false);

  return (
    <header className="custom-header">
      <div className="custom-logo-container">
        {/* <img src={logo} alt="Logo" className="custom-logo" /> */}
        <Link to="/">
  <img src={logo} alt="Logo" className="custom-logo" />
</Link>
      </div>

      <div 
        className={`custom-nav-toggle ${menuOpen ? "custom-open" : ""}`} 
        onClick={toggleMenu}
        aria-label="Toggle menu"
        role="button"
        tabIndex={0}
        onKeyDown={(e) => { if(e.key === 'Enter' || e.key === ' ') toggleMenu(); }}
      >
        <span></span>
        <span></span>
        <span></span>
      </div>

      <nav className={`custom-nav ${menuOpen ? "custom-active" : ""}`}>
        <NavLink to="/" className="custom-link" onClick={closeMenu} end>Home</NavLink>
        <NavLink to="/about" className="custom-link" onClick={closeMenu}>About Us</NavLink>
        <NavLink to="/services" className="custom-link" onClick={closeMenu}>Services</NavLink>
        <NavLink to="/projects" className="custom-link" onClick={closeMenu}>Projects</NavLink>
        <NavLink to="/companyCulture" className="custom-link" onClick={closeMenu}>Company Culture</NavLink>
        <NavLink to="/contact" className="custom-link" onClick={closeMenu}>Contact Us</NavLink>
       <NavLink to="/contact" className="custom-button" onClick={closeMenu}>
        Get a Quote
      </NavLink>
      </nav>
    </header>
  );
};

export default Header;
